import { gql } from "graphql-tag";

const BuildingUnitFragment = gql`
  fragment BuildingUnitFragment on BuildingUnit {
    id
    name
    bedrooms
    bathrooms
    occupancyMin
    occupancyMax
    rentType
    rentValue
    sqft
    floor
    occupied
    isReferral
    referralOrg
    accessibility
    buildingId
    fundingSource
    incomeDesignation
    preference
  }
`;

export const QUERY_PROPERTY_BUILDINGS = gql`
  query PropertyBuildings($propertyId: ID!) {
    propertyBuildings(propertyId: $propertyId) {
      id

      name
      type
      bin
      phase

      address1
      address2
      city
      state
      zip
    }
  }
`;
export const UPDATE_BUILDING = gql`
  mutation UpdateBuilding($id: ID!, $input: UpdateBuildingInput!, $propertyId: ID!) {
    updateBuilding(id: $id, input: $input, propertyId: $propertyId) {
      id
      name
    }
  }
`;
export const CREATE_BUILDING = gql`
  mutation CreateBuilding($input: BuildingInput!, $propertyId: ID!) {
    createBuilding(input: $input, propertyId: $propertyId) {
      id
      name
    }
  }
`;
export const DELETE_BUILDING = gql`
  mutation DeleteBuilding($id: ID!, $propertyId: ID!) {
    deleteBuilding(id: $id, propertyId: $propertyId) {
      id
    }
  }
`;

export const QUERY_BUILDING_UNITS = gql`
  query ListBuildingUnits($buildingId: ID!) {
    buildingUnits(buildingId: $buildingId) {
      ...BuildingUnitFragment
    }
  }
  ${BuildingUnitFragment}
`;

export const CREATE_BUILDING_UNIT = gql`
  mutation CreateBuildingUnit($buildingUnit: BuildingUnitInput!) {
    createBuildingUnit(buildingUnit: $buildingUnit) {
      ...BuildingUnitFragment
    }
  }
  ${BuildingUnitFragment}
`;

export const UPDATE_BUILDING_UNIT = gql`
  mutation UpdateBuildingUnit($id: ID!, $buildingUnit: UpdateBuildingUnitInput!) {
    updateBuildingUnit(id: $id, buildingUnit: $buildingUnit) {
      ...BuildingUnitFragment
    }
  }
  ${BuildingUnitFragment}
`;

export const DELETE_BUILDING_UNIT = gql`
  mutation DeleteBuildingUnit($id: ID!) {
    deleteBuildingUnit(id: $id) {
      id
    }
  }
`;
